import { push } from 'redux-first-history';

import { getJwtExpiration } from 'utils/authorization/utils/auth';
import { openFlashMessage } from 'components/utils/flashMessages';

import {
  isPublicJobBoardPath,
  isPublicPortalPath,
  logoutRedirect,
} from './helpers';
import { FlashDefinition } from './flashDefinition';

export const sessionExpired = () => {
  const expirationToken = getJwtExpiration();

  if (!expirationToken) {
    return true;
  }
  const expirationSeconds = expirationToken.payload.exp;
  const nowSeconds = Math.ceil(new Date().getTime() / 1000);

  return nowSeconds >= expirationSeconds;
};

export const handleExpirationTimer = (initialExpirationSeconds, dispatch) => {
  if (sessionExpired()) {
    clearExpirationTimer();
    handleSessionExpired(dispatch);
    return;
  }

  const expirationToken = getJwtExpiration();
  const expirationSeconds = expirationToken.payload.exp;
  if (initialExpirationSeconds !== expirationSeconds) {
    setExpirationTimer(dispatch);
  }
};

export const handleSessionExpired = (dispatch) => {
  if (
    !isPublicPortalPath(window.location) &&
    !isPublicJobBoardPath(window.location)
  ) {
    openFlashMessage(FlashDefinition.sessionExpired, { id: 'sessionExpired' });
  }

  dispatch(push(logoutRedirect()));
};

export const setExpirationTimer = (dispatch) => {
  clearExpirationTimer();

  const expirationToken = getJwtExpiration();
  if (!expirationToken) {
    return;
  }

  const initialExpirationSeconds = expirationToken.payload.exp;
  const expirationTimer = setTimeout(
    () => handleExpirationTimer(initialExpirationSeconds, dispatch),
    Math.ceil(initialExpirationSeconds - new Date().getTime() / 1000) * 1000
  );
  localStorage.setItem('expirationTimer', expirationTimer);
};

export const clearExpirationTimer = () => {
  const expirationTimer = localStorage.getItem('expirationTimer');

  if (expirationTimer) {
    clearTimeout(parseInt(expirationTimer, 10));
    localStorage.removeItem('expirationTimer');
  }
};
